import React from 'react'
import { Routes, Route, Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Stack, Typography, Button, useTheme } from '@mui/material'

import { Navigate } from 'router'
import { useModal } from 'store'
import AuthenticatedLayout from 'components/AuthenticatedLayout'

import AuthRoutes from './pages/Auth'
import StatsRoutes from './pages/Stats'
import HomeRoutes from './pages/Home'
import RanRoutes from './pages/Ran'
import CouponsRoutes from './pages/Coupons'
import SupervisionRoutes from './pages/Supervision'
import StreamCastRoutes from './pages/StreamCast'
import DocumentRoutes from './pages/Documents/routes'
import ContactsRoutes from './pages/Contacts'
import AdvertisementsRoutes from 'pages/Advertisements/routes'
import ProfileRoutes from './pages/Profile/routes'
import VoipRoutes from 'pages/Voip'
import IPTVRoutes from 'pages/IPTV/routes'
import SilentModeRoutes from 'pages/SilentMode/routes'
import WANRoutes from 'pages/WAN/routes'
import ProjectsRoutes from './pages/Projects/routes'
import BypassRoutes from './pages/Bypass'
import EventSsidsRoutes from './pages/EventSsids'
import ModalDemo from './pages/Auth/Demo'
import ConnectedUsersRoutes from './pages/ConnectedUsers'
import AccessPointZones from './pages/AccessPointZones'
import MonitoringSsids from './pages/MonitoringSsids'
import Mailer from './pages/Mailer'
import AdminSites from './pages/AdminSites'

const NotFound = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const theme = useTheme()
  return (
    <Stack flex={1} justifyContent={'center'} alignItems={'center'}>
      <Stack direction={'row'} gap={2}>
        <i className={'fa-solid fa-wifi'} style={{fontSize: 40, alignSelf: 'center', color: theme.palette.grey[700]}}/>
        <Stack gap={1}>
          <Typography variant={'caption'} sx={{fontSize: 13}}>{t('ui_elements.page_not_found')}</Typography>
          <Button variant={'contained'} size={'xs'} color={'primary'} onClick={() => navigate('/')}>{t('ui_elements.back_to_home')}</Button>
        </Stack>
      </Stack>
    </Stack>
  )
}
const Layout = () => {
  const [modal] = useModal()

  return (
    <AuthenticatedLayout>
      {
        modal === 'demo' && <ModalDemo />
      }
      <Outlet />
    </AuthenticatedLayout>
  )
}

const routes = () => (
  <Routes>
    <Route path="" element={<Layout />}>
      <Route path="" key="home" element={<Navigate pathname="/dashboard" />} />
      {ProfileRoutes({ path: '/profile' })}
      {DocumentRoutes({})}
      {HomeRoutes({ path: '/dashboard' })}
      {SupervisionRoutes({ path: '/monitoring' })}
      {CouponsRoutes({ path: '/codes' })}
      {StreamCastRoutes({ path: '/stream-cast' })}
      {StatsRoutes({ path: '/stats' })}
      {RanRoutes({ path: '/ran' })}
      {ContactsRoutes({  })}
      {AdvertisementsRoutes({path : '/advertisements'})}
      {VoipRoutes({path : '/voip'})}
      {IPTVRoutes({path: '/iptv'})}
      {SilentModeRoutes({path: '/silent-mode'})}
      {WANRoutes({})}
      {ProjectsRoutes({ path: '/projects' })}
      {BypassRoutes()}
      {ConnectedUsersRoutes()}
      {EventSsidsRoutes()}
      {AccessPointZones()}
      {MonitoringSsids()}
      {Mailer()}
      {AdminSites()}
    </Route>
    {AuthRoutes({})}
    {<Route path="*" key="404" element={<NotFound />} />}
  </Routes>
)

export default routes
